/**
 * Закон закупки приходит в разных видах: форма — «44», сервис тендеров (база) — «fz44»,
 * чат/ИИ-агент — «44-ФЗ», интеграция — «FZ44»/«PP615». Приводим к ключу формы
 * (44/223/615/185/275) или "commerce". Зеркало app/broker/dictionaries.norm_law.
 */
export function normLaw(v: unknown): string | null {
  const t = String(v ?? "").trim().toLowerCase().replace("ё", "е");
  if (!t) return null;
  if (/ком|com|кбг|частн/.test(t)) return "commerce";
  const m = t.match(/(44|223|615|185|275)/);
  return m ? m[1] : null;
}

const LABELS: Record<string, string> = {
  "44": "44-ФЗ", "223": "223-ФЗ", "615": "615-ПП", "185": "185-ФЗ", "275": "275-ФЗ", commerce: "коммерческая",
};

/** Подпись закона для показа: «fz44» → «44-ФЗ». Нераспознанное — как есть. */
export function lawLabel(v: unknown): string {
  const k = normLaw(v);
  return k ? LABELS[k] : String(v ?? "—");
}

/** Значение для селекта формы: распознанный госзакон, иначе прежнее. */
export function formLaw(v: unknown, fallback: string): string {
  const k = normLaw(v);
  return k && k !== "commerce" ? k : fallback;
}

type TenderAmounts = {
  applicationGuaranteeAmount?: number | null; contractGuaranteeAmount?: number | null;
  warrantyGuaranteeAmount?: number | null;
};

/**
 * Сумма обеспечения из извещения под вид гарантии — ровно своя, без подмены:
 *  • на участие — обеспечение заявки;
 *  • на исполнение (с авансом/без) — обеспечение исполнения контракта;
 *  • на гарантийные обязательства — обеспечение гарантийных обязательств;
 *  • на возврат аванса — размер аванса в извещении не указан → null (вводит брокер).
 * 0/пусто — «не требуется или не указано числом» (у 223-ФЗ часто «Согласно документации»)
 * → null. Раньше при отсутствии своей суммы подставлялась чужая (заявка вместо исполнения),
 * а ноль проходил через «??» и затирал сумму в форме.
 */
export function guaranteeAmountFor(t: TenderAmounts, gtype: string): number | null {
  const pos = (v: number | null | undefined) => (typeof v === "number" && v > 0 ? v : null);
  if (gtype === "bid") return pos(t.applicationGuaranteeAmount);
  if (gtype === "exec_no_adv" || gtype === "exec_adv") return pos(t.contractGuaranteeAmount);
  if (gtype === "warranty") return pos(t.warrantyGuaranteeAmount);
  return null;
}
